import { render } from "./OverallAuthorStatistics.vue?vue&type=template&id=1e22379c&scoped=true"
import script from "./OverallAuthorStatistics.vue?vue&type=script&lang=js"
export * from "./OverallAuthorStatistics.vue?vue&type=script&lang=js"

import "./OverallAuthorStatistics.vue?vue&type=style&index=0&id=1e22379c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e22379c"

export default script